import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import ContentListsDashboard from '../components/dashboard/ContentListsDashboard';

import { __t, applyTranslations } from 'utils/language';
import { getCollectionsSubnavigation } from 'utils/navigation';

import type { LocationWindow, Organization } from 'types';
import type { Dispatch } from 'redux';

applyTranslations(require('./content-lists-page.i18n.json'));
applyTranslations(require('locales/common/collabary-common.i18n.json'));

type OwnProps = {
  location: LocationWindow
};

type StateProps = {
  org: Organization
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by redux connect
} & OwnProps & StateProps;

class ContentListsDashboardPage extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { org, location } = this.props;
    const orgId = org.id;
    const subnavigation = orgId ? getCollectionsSubnavigation(orgId) : null;

    return (
      <Page
        documentTitle={__t('content_lists_page.browser_title')}
        subnavigation={subnavigation}
      >
        <ContentListsDashboard
          location={location}
        />
      </Page>
    );
  }
}

const mapStateToProps = ({ organizations }): StateProps => ({
  org: organizations.currentOrganization
});

export default connect(mapStateToProps)(ContentListsDashboardPage);
